import { FormInput } from "../../components/ui/Input/FormInput/FormInput";
import { AuthPageShell } from "./components/AuthPageShell";
import { AuthSubmitButton } from "./components/AuthSubmitButton";
import { AuthTextLink } from "./components/AuthTextLink";
import { PasswordField } from "./components/PasswordField";
import { AUTH_COPY, AUTH_ROUTES, FIELD_MAX_LENGTH } from "./constants/auth.constants";
import { useLoginViewModel } from "./hooks/useLoginViewModel";
import { loginFormRules } from "./validation/authFormRules";

/**
 * Redesigned sign-in screen (shadcn + Tailwind), gated behind
 * `ENABLE_AUTH_UI_REDESIGN` — see `src/routes/commonRoutes.tsx`. All session
 * logic (login -> profile -> company -> tenant switch -> navigate) lives in
 * `useLoginSession` via `useLoginViewModel`; the legacy `Login.tsx` is kept
 * untouched behind the flag.
 */
const LoginNew = () => {
  const { methods, onSubmit, isPending } = useLoginViewModel();

  return (
    <AuthPageShell
      eyebrow={AUTH_COPY.login.eyebrow}
      title={AUTH_COPY.login.title}
      subtitle={AUTH_COPY.login.subtitle}
      methods={methods}
      onSubmit={onSubmit}
    >
      <FormInput
        control={methods.control}
        name="email"
        label="Email"
        type="email"
        placeholder="Enter email"
        maxLength={FIELD_MAX_LENGTH.email}
        disabled={isPending}
        data-testid="login-email"
        {...loginFormRules.email}
      />
      <PasswordField
        control={methods.control}
        name="password"
        label="Password"
        placeholder="Enter password"
        maxLength={FIELD_MAX_LENGTH.password}
        disabled={isPending}
        data-testid="login-password"
        {...loginFormRules.password}
      />
      <div className="tw-text-right">
        <AuthTextLink to={AUTH_ROUTES.forgotPassword} className="tw-inline">
          Forgot password?
        </AuthTextLink>
      </div>
      <AuthSubmitButton label={AUTH_COPY.login.submitLabel} isPending={isPending} />
    </AuthPageShell>
  );
};

export default LoginNew;
